module.exports = __webpack_public_path__ + "static/media/carousel-img3.c93bd056.png";